<template>
    <div class="newsDetail-page">
        <div class="container">
            <div class="title-wrap">
                <h1>{{mainData.title}}</h1>
                <p class="info">
                    来源 {{mainData.author}}
                    <span class="time">{{mainData.time || '-'}}</span>
                </p>
            </div>
            <div class="content" v-if="mainData.id == 1">
                <p>本周「胡润百富」发布了今年的「中国最具投资价值新星企业」年度榜单，专注于 3C 数码租赁业务的「探物（TanWorth）」荣登榜单「深圳 50 强」之列！</p>
                <p>「中国最具投资价值新星企业」榜中囊括了高新科技硬件、互联软件、医疗服务，以及电商零售等各行企业，探物则是该榜单深圳 Top 50 中唯一一家「数码租赁」企业。</p>
                <img class="block width-full" src="https://mmbiz.qpic.cn/mmbiz_jpg/Cw4iaDs3F8TCKaMl9VfEyNhg67Yzou8IBqYS2QpAh4jDk0JEeb191b26xgxwR7IvOND7PWJickRvwUiaYIBszPHTg/640?wx_fmt=jpeg&tp=webp&wxfrom=5&wx_lazy=1&wx_co=1">
                <p>探物诞生于 2016 年 3 月，总部设立在深圳，辐射全国，目前在北京设有网点，是国内最早的新型 3C 数码租赁平台之一；</p>
                <p>探物致力于「信用租赁」的推进，与蚂蚁金服达成战略性合作，2019 年上半年，更接入了蚂蚁区块链，让广大符合信用等级的用户不再受限于高昂的押金，租到自己心仪的数码产品。</p>
                <img class="block width-full" src = "https://mmbiz.qpic.cn/mmbiz_jpg/Cw4iaDs3F8TCKaMl9VfEyNhg67Yzou8IBO2uQU187zaTb0KX8bXbBHASUspDEvZAfnVvDxYJMBAfOqIqed0fRKA/640?wx_fmt=jpeg&tp=webp&wxfrom=5&wx_lazy=1&wx_co=1">
                <p>这一次探物入选「2019 中国最具投资价值新星企业」，不仅是市场给予探物的肯定，更是对整个数码租赁行业，乃至是「新租赁经济」高度的肯定。</p>
                <p>「租赁」这一大产业在欧美发达国家已十分成熟，接受度非常高；放眼国内，当下的年轻人的消费观念正经历着「消费升级」，同时又「回归理性」，这两者并不矛盾：</p>
                <p>经过近年市场的培养，越来越多的消费者开始懂得什么才是真正的好产品，更愿意去尝试、体验新鲜、更有品质的产品与服务；这群人往往更清楚自身需求，不会盲目地过度消费 -- 这就给国内的「新租赁经济」创造了市场需求和充足的成长养分。</p>
                <img class="block width-full" src="https://mmbiz.qpic.cn/mmbiz_jpg/Cw4iaDs3F8TCKaMl9VfEyNhg67Yzou8IBlJMyUneAT2Stvt3EZLfabE5AL8qKibicB4TpWQ6O5LEyyQrJIu1sZYoA/640?wx_fmt=jpeg&tp=webp&wxfrom=5&wx_lazy=1&wx_co=1" alt="">
                <p>探物的平台上有相机、镜头、无人机、游戏、VR、影音、显卡等丰富的数码品类，特别是相机、无人机等强需求却低频使用的数码产品最受欢迎，以租代买，拒绝闲置浪费，更符合「新租赁经济」的理念。用户可以在线下单，等待产品运输上门后即可享用，也能亲自到最近的网点下单自取，实现线上与线下相互导流。</p>
                <p>探物在选品上与众多一线品牌合作，为消费者提供最新、最丰富、最好用的数码产品，还与供应商有着密切的合作，拥有完整的上下游供应链，从采购、租赁、归还、维护，甚至到产品最后的残值处理，都形成完整的生态闭环。</p>
                <img class="width-full block" src="https://mmbiz.qpic.cn/mmbiz_jpg/Cw4iaDs3F8TCKaMl9VfEyNhg67Yzou8IBje03EdWS8Av0icAvsxJLeJtV6sCAicHm7Tw7hDfq4ibkYYeS7icS7rENibQ/640?wx_fmt=jpeg&tp=webp&wxfrom=5&wx_lazy=1&wx_co=1" alt="">
                <p>为给消费者更有品质的服务，探物与蚂蚁金服、顺丰速运等金融、服务类行业巨头达成战略性合作，大大简化了服务流程，为用户提供流畅、友好的消费流程和体验，更能免去消费者对押金、运输破损等顾虑；依托芝麻信用完善的风控体系，探物本身更能过滤掉潜在的风险，极大地降低了业务运转的损失。</p>
                <img class="width-full block" src="https://mmbiz.qpic.cn/mmbiz_jpg/Cw4iaDs3F8TCKaMl9VfEyNhg67Yzou8IBTIa5AvYlBYHFQBoeibBzcQOsYCIhhg2wg98GZ3ABatzc8IKMe4t3Uhg/640?wx_fmt=jpeg&tp=webp&wxfrom=5&wx_lazy=1&wx_co=1" alt="">
                <p>2018 年，探物更获得了蚂蚁金服千万元级的战略投资，壮大了企业团队同时，还为支付宝的芝麻信用创造了更丰富的使用场景。</p>
                <img class="width-full block" src="https://mmbiz.qpic.cn/mmbiz_jpg/Cw4iaDs3F8TCKaMl9VfEyNhg67Yzou8IB67MnmOAZ0lukhgibzzx9X3vvKaLg78Yo2ibrccO9VEqgfjkxjQTAibNZA/640?wx_fmt=jpeg&tp=webp&wxfrom=5&wx_lazy=1&wx_co=1" alt="">
                <p>在「新租赁经济」被越来越多国人接受的大背景下，探物切中了数码租赁的使用场景，再加上企业良性的运转下，挤上了数码租赁行业的排头兵。</p>
                <p>而入选「中国最具投资价值新星企业」不仅收获了来自权威的肯定，更佐证了「新租赁经济」这一新兴市场明朗的前景。</p>
                <p>然而这一行业在国内尚处于起步阶段，有欧美国家作参考，再加上中国市场独特而强劲的创新力，「新租赁经济」的市场潜力想必更巨大。</p>
            </div>
            <div class="content" v-else>
                <div v-for="(item,index) in mainData.content" :key="index">
                    <template v-if="item.type == 1">
                        <p v-for="(item2,index2) in item.list" :key="index2">{{item2}}</p>
                    </template>
                    <template v-else-if="item.type == 2">
                        <img v-for="(item2,index2) in item.list" :key="index2" class="width-full block" :src="item2" alt="">
                    </template>
                </div>
            </div>
            <shareBox :shareData = "shareData"></shareBox>
            <!-- <p class="more-title">更多产品评测</p>
            <div class="assess-list">
                <newsItem v-for="(item,index) in listData" :key="index" :item = "item" class="item" @click.native="goDetail(item)"></newsItem>
            </div> -->
        </div>
    </div>
</template>

<script>
	import Vue from 'vue'
    import { CONFIG,network } from '@assets/js/apis';
    import newsItem from '@components/newsItem';
    import shareBox from '@components/shareBox';
    export default {
		data() {
			return {
                askData:{},
                mainData:{},
                listData:[],
                shareData:{},
                newsData:[
                    {
                        id:1,
                        title:'探物荣登「胡润百富 2019 中国最具投资价值新星企业」榜！',
                        time:'2019.06.29',
                        author:'探物科技',
                    },
                    {
                        id:2,
                        title:'36氪首发 | 定位新奇科技数码租赁平台，「探物」获蚂蚁金服数千万元天使轮融资',
                        time:'2018.04.13',
                        author:'36kr记者 高歌',
                        content:[
                            {
                                type:1,
                                list:[
                                    '36氪获悉，新奇科技数码租赁平台「探物」获数千万元天使轮融资，资方为蚂蚁金服。这也是蚂蚁金服在共享租赁领域连续投资的四个项目之一。',
                                    '「探物」创立于2016年3月，定位新奇科技数码租赁平台，平台涉及品类包括游戏主机、运动相机、无人机、单反相机及镜头、VR智能穿戴、音箱及耳机等。',
                                    '新科技产品层出不穷，购买成本高，买不如租的观念，逐渐被越来越多的人所接受。探物希望，让用户以更低的成本获取更多元的体验，将科技产品引入大众消费生活。 ',
                                    '具体来说，探物和芝麻信用合作，用户可“免押金”体验各类产品；线上下单线下自取，线上线下相互导流。盈利模式当前以租金收入为主，依靠快速周转，缩短回本周期。 ',
                                    '在选品逻辑上，其一，选择有租赁需求、且价位2000-5000元之间的产品；其二，探索好物、强调品质。',
                                    'CEO李鸿告诉36氪，选择2000-5000元的价格区间，原因在于消费主力群体在这个区间内，5000元以上的更多为专业级用户，探物更多面向的是大众市场。而“探索好物”，即探物名字的由来，尽管产品并不由平台生产，但要营造一个新奇好物的平台氛围。',
                                ]
                            },
                            {
                                type:2,
                                list:[
                                    'https://mmbiz.qpic.cn/mmbiz_jpg/Cw4iaDs3F8TBE7P3vFacNLvicjU1wdtSBcwQcSqictibkRD5TU6dDfjeTPlPw6kLHJqfz0icTw8h9j0UG3QHVD5Q5SQ/640?wx_fmt=jpeg&tp=webp&wxfrom=5&wx_lazy=1&wx_co=1'
                                ]
                            },
                            {
                                type:1,
                                list:[
                                    '平台上既有场景化的短时租赁需求，也有“去场景化”的长时段租赁需求。根据不同的租赁需求，探物也有着不同的定价策略：短时租赁单日的租金相对高，租赁时间越长、单日租金会有一个抛物线的降低。',
                                    '对于共享租赁项目而言，只有用户沉淀在平台上，才能形成最大的价值。在如何留存用户这一点上，租赁服务之外，探物还有内容的产出。比如由PGC完成的每周开箱测评视频，比如对国外科技视频的编译，同时鼓励UGC内容的分享和沉淀，增加社交属性。',
                                    '从发现好物、线上下单到线下自提，在线上的部分，探物有支付宝、小程序、APP、官网等线上入口；线下渠道方面，已在深圳、武汉、杭州、厦门、北京等地铺设了线下体验点。探物观察到，用户对线下的需求仍然较大：一方面有教学需求，现场技术讲解；另一方面科技产品相对精密，需要线下实物的体验。',
                                    '此外，探物和商户合作，在购买之外给到用户多一种“租”的选择。对于商户而言，有线上流量的导入，也给用户提供了更多的增值服务。',
                                    '“做租赁平台，重风控、重供应链、重服务、重资本。” 李鸿表示。租赁平台所面临的用户履约风险以及跌价风险，需要后端处理能力及风控体系的搭建。',
                                    '在供应链端，探物在上游端和品牌方/渠道商合作，初期直接购买，后期由品牌直接供货，进行租赁分成；在下游端，平台的残值处理可直达国内的二手终端市场。',
                                    '风控体系依托于芝麻信用，根据用户的芝麻分及历史履约情况给予免押额度，同时与同盾科技等第三方公司合作，识别过滤潜在的风险信息，自建行业风险数据库。',
                                    '根据公司提供的数据，以GoPro为例，一年后的残值在60%左右，平均每月能够周转2.1次，回本周期2.7个月。现已有6家线下门店，200+SKU。',
                                    '本轮融资将用于团队建设和市场推广，蚂蚁金服方面，也将为平台带来流量、供应链及风控体系等方面的支持。'
                                ]
                            }
                        ]
                    },
                    {
                        id:3,
                        title:'仅有21人的公司，凭什么被十几家风投疯抢？',
                        time:'2018.02.01',
                        author:'WiFi新连接 大卷',
                        content:[
                            {
                                type:1,
                                list:[
                                    '自从任天堂的switch刷屏之后,“朋友圈晒iPhone X”的逼格就此被取代,这么拉风的神器，小wifi也一心想把玩。'
                                ]
                            },
                            {
                                type:2,
                                list:[
                                    'https://mmbiz.qpic.cn/mmbiz_gif/4kFaPJIbRnYlQbGZFlnqoISiaQdRMwBfyMfDTeHI9u7nTfqZPm5yPoNfr8eKfsL10uDRiaU3rz87hAzXlNJP5Ktg/640?wx_fmt=gif&tp=webp&wxfrom=5&wx_lazy=1'
                                ]
                            },
                            {
                                type:1,
                                list:[
                                    '然而除了房贷、车贷,每月还得还新买的皮衣的分期,可谓负债累累。'
                                ]
                            },
                            {
                                type:2,
                                list:[
                                    'https://mmbiz.qpic.cn/mmbiz_gif/4kFaPJIbRnYlQbGZFlnqoISiaQdRMwBfyoTWmeAvPMQoNa91lXbfNKwWlPMWFbLexkXiaQQfxbfONcYUR76wu0Ww/640?wx_fmt=gif&tp=webp&wxfrom=5&wx_lazy=1'
                                ]
                            },
                        ]
                    }
                ]
			}
        },
        components: {
            newsItem,
            shareBox,
		},
        created(){
            this.mainData = this.newsData.find(item => item.id == this.$route.query.id);
        },
        methods:{
            initData(){
                network(CONFIG.themeDetail,this.askData).then(res => {
                    let details = res.details;
                    this.mainData = details;
                    for(let i = 0 ; i < 3 ; i++){
                        this.listData.push({
                            id:details.themeId,
                            image:details.themeImage,
                            title:details.themeTitle,
                            time:this.formatTime(details.datetime)
                        })
                    }
                    this.shareData = {
                        image:details.themeImage,
                        title:details.themeTitle,
                        url:window.location.href,
                    }
                });
            },
        }
    }
</script>

<style lang="scss">
    .newsDetail-page{
        .title-wrap{
            color: #333333;
            padding-bottom: 20px;
            padding-top: 50px;
            h1{
                font-size: 36px;
                line-height: 1.3888;
                margin-bottom: 10px;
            }
            .info{
                font-size: 14px;
                line-height: 1.4285;
                .time{
                    padding-left: 25px;
                }
            }
        }
        .content{
            padding: 30px 0 80px;
            font-size: 18px;
            line-height: 1.888;
            border-bottom: 1px solid #EEEEEE;
            border-top: 1px solid #EEEEEE;
            min-height: 500px;
            p + p{
                margin-top: 20px;
            }
            img{
                margin: 30px 0;
            }
        }
        .more-title{
            font-size: 26px;
            line-height: 1.423;
            margin-bottom: 24px;
            text-align: center;
            letter-spacing: 1px;
        }
        .assess-list{
            padding-bottom: 100px;
        }
    }
</style>



// WEBPACK FOOTER //
// src/pages/content/children/newsDetail.vue